export const STORE_CREDIT = 'STORE_CREDIT'
export const CREDIT_CARD = 'CREDIT_CARD'
export const PAYPAL = 'PAYPAL'
export const APPLEPAY = 'APPLEPAY'
